import NumberFlow from '@number-flow/react';
import React, { ReactElement } from 'react';

import { Checkbox } from 'src/components/checkboxes/Checkbox';
import { ConfigurationCriterionChildrenConfig } from 'src/features/configuration/configurationCriteria/configs/ConfigurationCriterionChildrenConfig';
import { ConfigurationCriterionBadge } from 'src/features/configuration/configurationCriteria/ConfigurationCriterionBadge';
import { ConfigurationCriteriaEnum } from 'src/features/configuration/configurationCriteria/enums/ConfigurationCriteriaEnum';
import { ConfigurationCriteriaIdsEnum } from 'src/features/configuration/configurationCriteria/enums/ConfigurationCriteriaIdsEnum';
import { useConfigurationCriterion } from 'src/features/configuration/configurationCriteria/hooks/useConfigurationCriterion';
import type { OpenSessionCriterion } from 'src/services/api/getOpenSessionCriteria';

type ConfigurationCriterionProps = {
  criterionKey: ConfigurationCriteriaEnum;
  criterion: OpenSessionCriterion;
};

export function ConfigurationCriterion({
  criterionKey,
  criterion,
}: ConfigurationCriterionProps): ReactElement {
  const criterionChildren = ConfigurationCriterionChildrenConfig(criterion);
  const {
    isAddingCriteria,
    isDeletingCriteria,
    isChecked,
    handleChangeCriteria,
  } = useConfigurationCriterion(criterion);

  return (
    <div className='flex w-full flex-wrap items-center gap-2 text-sm'>
      <ConfigurationCriterionBadge
        id={
          ConfigurationCriteriaIdsEnum[
            criterionKey as keyof typeof ConfigurationCriteriaIdsEnum
          ]
        }
      />
      <Checkbox
        className='ml-1 size-5 cursor-pointer'
        checked={isChecked}
        onChange={(e) => handleChangeCriteria(e.target.checked)}
        disabled={isAddingCriteria || isDeletingCriteria}
      />
      <span>-</span>
      {criterionChildren[criterionKey]}
      <span className='text-layout-foreground-secondary'>
        (<NumberFlow value={criterion.products.length} /> refs)
      </span>
    </div>
  );
}
